module.exports = __webpack_public_path__ + "static/header-e95eec3fccf3d18d8a9d7a8ca70e327f.jpg";